var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionWrapper',{attrs:{"is-async":""},scopedSlots:_vm._u([{key:"sticky",fn:function(){return [_c('CommissionsFilters')]},proxy:true}])},[_c('CommissionsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }